import { Form, Input, ModalProps, FormProps, Modal, Select, InputNumber, useSelect, message } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory, updateProjectReportThemeIds } from 'gql/mutations'
import { findProjectFieldName, getReportThemeDataByTopicId } from 'gql/query'
import { IProject, ISubject, ITopic } from 'interfaces'
import { useEffect } from 'react'

type EditReportThemeProps = {
  modalProps: ModalProps
  formProps: FormProps
  // refetchProjectDetails: () => void
  // projectDetails?:any[]
}

export const EditReportTheme: React.FC<EditReportThemeProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()

  // const { selectProps: topicSelectProps } = useSelect<ITopic>({
  //   resource: 'topics',
  //   fetchSize: 1000,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'created_at', order: 'desc' }],
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })
  const { selectProps: themeSelectProps } = useSelect<ITopic>({
    resource: 'themes',
    fetchSize: 100000,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    filters: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    sort: [{ field: 'created_at', order: 'desc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  // const { selectProps: projectSelectProps } = useSelect<IProject>({
  //   resource: 'project_config',
  //   fetchSize: 1000,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name', 'report_theme_ids'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })
  const onFinish = async (values: any) => {
    formProps?.form?.resetFields()
    if (values && values?.name?.trim() && values?.theme_ids && values?.theme_ids?.length > 0) {
      values.name = values?.name?.trim()
      const isNameStillSame = values?.name === formProps?.initialValues?.name
      if (!isNameStillSame) {
        const isNameRepeated: any = await findProjectFieldName(values.name, 'name', 'report_themes')
        // Name is repeated
        if (isNameRepeated && isNameRepeated?.report_themes?.length > 0) {
          message.error('Report theme name is already present... please make sure report themes are unique')
          return false
        }
      }
      //extracting project_ids from the object
      // const { project_ids, ...newValues } = values
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          updated_by: user?.id,
        })
      )
    } else {
      message.error(`Name and Topic are required please ensure these values are present`)
    }
  }

  // useEffect(() => {
  //   if (formProps && formProps?.initialValues && projectDetails && projectDetails?.length > 0) {
  //     const projectsArray: any = []
  //     projectDetails?.forEach((project: any) => {
  //       if (project?.report_theme_ids && project?.report_theme_ids?.length > 0) {
  //         if (project?.report_theme_ids.includes(formProps?.initialValues?.id)) {
  //           projectsArray.push(project.id)
  //         }
  //       }
  //     })
  //     formProps.initialValues.project_ids = projectsArray
  //   }
  // }, [formProps])
  return (
    <Modal {...modalProps} title="Edit ReportTheme">
      <Form
        {...formProps}
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then(async (response: any) => {
            if (response && response?.data?.id) {
              // const alreadyMappedProjects = formProps?.initialValues?.project_ids || []
              // const updatedProjectDetails = values?.project_ids || []
              // const projectsNeedToRemove = alreadyMappedProjects.filter((item: any) => !updatedProjectDetails.includes(item))
              // const projectsNeedToAdd = updatedProjectDetails.filter((item: any) => !alreadyMappedProjects.includes(item))
              // // if any projects need to remove
              // if (projectsNeedToRemove?.length > 0) {
              //   for (const removeItem of projectsNeedToRemove) {
              //     const removeItemDetails: any = await findProjectFieldName(removeItem, 'id', 'project_config')
              //     if (removeItemDetails?.project_config[0]) {
              //       const reportThemeLists = removeItemDetails?.project_config[0]?.report_theme_ids
              //       console.log(reportThemeLists, 'report theme before')
              //       //if item present removing that value
              //       reportThemeLists.indexOf(response?.data?.id) !== -1 && reportThemeLists.splice(reportThemeLists.indexOf(response?.data?.id), 1)
              //       const removeProjects = await updateProjectReportThemeIds(removeItem, reportThemeLists, 'removeItem')
              //       if (removeProjects) {
              //         console.log(response?.data?.id, 'Item removed', removeItem)
              //       }
              //     }
              //   }
              // }
              // // if any projects need to add
              // if (projectsNeedToAdd?.length > 0) {
              //   for (const addItem of projectsNeedToAdd) {
              //     const addProjects = await updateProjectReportThemeIds(addItem, response?.data?.id)
              //     if (addProjects) {
              //       console.log(response?.data?.id, 'added to this project:', addItem)
              //     }
              //   }
              // }
              // // refetching updated project details
              // await refetchProjectDetails()
              createUserHistory('report_themes', 'edit', response?.data?.id, user?.id, userRole)
            }
          })
          return response
        }}
      >
        <Form.Item
          label="ReportTheme Name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Please add an name',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Theme" name="theme_ids" rules={[{ required: true, message: 'Please select atleast one theme' }]}>
          <Select {...themeSelectProps} mode="multiple" />
        </Form.Item>
        {/* <Form.Item label="Projects" name="project_ids" labelCol={{ span: 24 }}>
          <Select {...projectSelectProps} mode="multiple" />
        </Form.Item> */}
        <Form.Item name="updated_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
